module.config(function($stateProvider) {

    $stateProvider.state('student.certificates', {
        templateUrl: 'empty',
        url: '/certificates',
        permissions: 'viewCertificates',
        abstract: true,
        resolve: {
            auth: function($checkPermissions, student, permissions) {
                if (student.has_enrollment || student.certificates > 0) {
                    return true;
                }
                return $checkPermissions('administerStudents', permissions);
            },
        },
    })

    .state('student.certificates.index', {
        url: '',
        templateUrl: "students/certificates/index",
        controller: 'CertificateIndexController',
        resolve: {
            certificates: function(ModelService, student) {
                return ModelService.getRelation('participant', student.id,
                                                'certificates');
            }
        },
    })

    .state('student.certificates.view', {
        url: '/:cert_id',
        templateUrl: "students/certificates/view",
        resolve: {
            certificate: function($stateParams, student, ModelService) {
                return ModelService.get('certificate', $stateParams.cert_id)
                    .then(ModelService.assertRelation('participant_id', student.id));
            }
        },
        controller: 'CertificateViewController',
    });
});
